<template>
	<div class="Forgot">
		<div class="forgot-box">
			<van-nav-bar>
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Forgot Password</div>
					</div>
				</template>
				<template #right>
					<div class="backColor" @click="back" >返回</div>
				</template>
			</van-nav-bar>

			<div class="forgot-form">
				<div class="title">通过邮箱找回密码 !</div>
				<div class="en-title">Please enter the registration <br /> by email or phone number</div>
				<div class="forgot-form-box">
					<van-form>
						<van-field
						placeholder="手机号" 
						v-model="userInfo.phone" 
						/>
						<van-field
						:type="isPassword ? 'password' : 'text'" 
						placeholder="重设密码" 
						v-model="userInfo.password"
						:right-icon="isPassword ? 'closed-eye' : 'eye-o'" 
						@click-right-icon="viewPassword" />
						<van-field 
						type="email" 
						placeholder="邮箱"
						v-model="userInfo.email"
						/>
						<van-field
						  v-model="userInfo.validCode"
						  center
						  clearable
						  placeholder="请输入短信验证码"
						>
						  <template #button>
						    <van-button size="small" type="primary" :disabled="isSend" @click="getEmailValidCode" >{{text}}</van-button>
						  </template>
						</van-field>
						<div class="clearfix forgot">
							<span class="fr" @click="goLogin">已有账号,立刻登陆</span>
						</div>
						<div class="forgot-btn">
							<van-button round block type="info" native-type="submit" @click="commit" color="#212572">立即找回</van-button>
						</div>
					</van-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "../assets/less/forgot.less";
	import { validForm } from '../assets/js/ValidForm'
	import { utils } from '../assets/js/utils'
	
	export default{
		data(){
			return{
				userInfo: {
					phone: '',
					password: '',
					email: '',
					validCode: ''
				},
				isPassword: true,
				text: '发送验证码',
				isSend: false,
			}
		},
		created() {
			
		},
		methods:{
			
			//返回上一级
			back(){
				this.$router.go(-1);
			},
			
			//查看密码
			viewPassword() {
				this.isPassword = !this.isPassword;
			},
			
			//前往登陆
			goLogin(){
				this.$router.push({name: 'Login'});
			},
			
			//获取验证码
			getEmailValidCode(){
				let time = 5;
				this.text = time + 's后可重新发送'
				this.isSend = true;
				
				let timer = setInterval( () => {
					if(time == 0){
						clearInterval(timer);
						this.isSend = false;
						this.text = '发送验证码';
					}else{
						time--;
						this.text = time + 's后可重新发送';
					}
				},1000)
				
				this.$toast.loading({
					message: '加载中...',
					//防止穿透
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner',
				})
				
				//序列化参数
				let data = utils.queryString({
					appkey: this.appkey,
					email: this.userInfo.email
				});
				
				this.axios({
					method: 'POST',
					//请求参数
					url: '/emailValidCode',
					data
				}).then(result =>{
					//关闭提示加载
					this.$toast.clear();
					this.$notify({
					  type: 'warning', 
					  message: result.data.msg
					})
				}).catch(err =>{
					this.$toast.clear();
				})
			},
								
								
			editPassword(){
				this.$toast.loading({
					message: '加载中...',
					//防止穿透
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner',
				})
				
				//序列化参数
				let data = utils.queryString({
					appkey: this.appkey,
					//注册时候的手机号
					phone: this.userInfo.phone,
					//新密码
					password: this.userInfo.password
				});
				
				this.axios({
					method: 'POST',
					//请求参数
					url: '/retrievePassword',
					data
				}).then(result =>{
					//关闭提示加载
					this.$toast.clear();
					if (result.data.code == 'L001') {
						this.$notify({
							type: 'primary', 
							message: result.data.msg + '3s之后跳转登陆页面' ,
						});
						setTimeout(() =>{
							this.$router.push({name: 'Login'});
						},3000)
					}
					this.$notify({ 
						type: 'primary', 
						message: result.data.msg,
					});
				}).catch(err =>{
					this.$toast.clear();
				})
			},
				
				//提交
				commit(){
				
				//修改密码的表单
				let o = {
					phone:{
						value: this.userInfo.phone,
						reg: /^1[3-9]\d{9}$/,
						errorMsg: '手机号格式不正确'
					},
					password:{
						value: this.userInfo.password,
						reg: /^[A-Za-z]\w{5,15}$/,
						errorMsg: '密码首字母开头6到16位'
					},
					email:{
						value: this.userInfo.email,
						reg: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
						errorMsg: '邮箱格式不正确'
					},
					validCode:{
						value: this.userInfo.validCode,
						reg: /^\d{6}$/,
						errorMsg: '验证码错误'
					},
				};
				
				//验证表单
				if(!validForm.valid(o)){
					//验证不通过
					return;
				}
				
				//序列化参数
				let data = utils.queryString({
					appkey: this.appkey,
					validCode: this.userInfo.validCode
				});
				
				
				//发起修改密码请求
				this.$toast.loading({
					message: '加载中...',
					//防止穿透
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner',
				})
				
				this.axios({
					method: 'POST',
					//请求参数
					url: '/checkValidCode',
					data
				}).then(result =>{
					//关闭提示加载
					this.$toast.clear();
					if (result.data.code == 'K001') {
						//验证成功
						this.editPassword();
					}else{
						this.$notify({
							type: 'primary', 
							message: result.data.msg,
						});
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			}			
		}
	}
</script>

<style>
</style>
